module.exports = __webpack_public_path__ + "media/flags/mc-f1916538.svg";